import { MapEditor } from "../../components/maps/MapEditor.js";
import { useSubjectContext } from "./useSubjectContext.js";
import { useEnsuredMap } from "./useEnsuredMap.js";
import { ErrorState, useT } from "@mmm/ui";
/** The subject's single subject-level mind map. */
export function SubjectMapTab() {
  const { subject } = useSubjectContext();
  const { map, error, retry } = useEnsuredMap(subject, null, subject.title);
  const t = useT();

  if (error) return <ErrorState title={t("maps.loadFailed")} onRetry={retry} />;
  if (!map) return null;
  return <MapEditor key={map.id} mindMapId={map.id} />;
}
